"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFacilityManagerActions = useFacilityManagerActions;
var react_1 = require("react");
var facility_1 = require("../features/apis/facility");
var message_dialog_1 = require("../features/thunks/message-dialog");
var dialogs_1 = require("../interfaces/dialogs");
var hooks_1 = require("../store/hooks");
var confirm_then_run_1 = require("../utils/confirm-then-run");
/** Assigning/removing a facility's own managers, from the facility detail page. */
function useFacilityManagerActions(facility, canEditFacility) {
    var _this = this;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _a = (0, react_1.useState)(null), removingFacilityManagerId = _a[0], setRemovingFacilityManagerId = _a[1];
    var removeFacilityManager = (0, facility_1.useRemoveFacilityManagerMutation)()[0];
    var _b = (0, facility_1.useAddFacilityManagersMutation)(), addFacilityManagers = _b[0], isAssigningFacilityManagers = _b[1].isLoading;
    var handleRemoveFacilityManager = function (managerId) {
        var _a, _b;
        if (!facility || !canEditFacility) {
            return;
        }
        var managerName = ((_b = (_a = facility.managers) === null || _a === void 0 ? void 0 : _a.find(function (manager) { return manager.id === managerId; })) === null || _b === void 0 ? void 0 : _b.name) || "this manager";
        (0, confirm_then_run_1.confirmThenRun)({
            dispatch: dispatch,
            confirmHeader: "Remove manager",
            confirmBody: "Remove ".concat(managerName, " as a manager of \"").concat(facility.name, "\"?"),
            confirmLabel: "Remove Manager",
            action: function () { return removeFacilityManager({ facilityId: facility.id, managerId: managerId }).unwrap(); },
            successHeader: "Manager removed",
            successBody: "".concat(managerName, " is no longer a manager of \"").concat(facility.name, "\"."),
            failureHeader: "Remove manager failed",
            failureBody: "Unable to remove this manager. Please try again.",
            onStart: function () { return setRemovingFacilityManagerId(managerId); },
            onSettled: function () { return setRemovingFacilityManagerId(null); },
        });
    };
    var handleAssignFacilityManagers = function (managerIds) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!facility) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, addFacilityManagers({ facilityId: facility.id, managerIds: managerIds }).unwrap()];
                case 1:
                    response = _a.sent();
                    if (!response.success) {
                        throw new Error(response.message || "Unable to assign managers.");
                    }
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Managers assigned",
                            body: "Added ".concat(managerIds.length, " manager(s) to \"").concat(facility.name, "\"."),
                            buttons: [{ type: dialogs_1.EMessageDialogButtonType.OK, label: "OK" }],
                        })).catch(function () { })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return { removingFacilityManagerId: removingFacilityManagerId, isAssigningFacilityManagers: isAssigningFacilityManagers, handleRemoveFacilityManager: handleRemoveFacilityManager, handleAssignFacilityManagers: handleAssignFacilityManagers };
}
